import { createContext, useContext } from 'react';

const ApplicationRootConfigurationContext = createContext({
  getSection: (name) => JSON.parse(document.getElementById('application').getAttribute(`data-${name}`)),
});

/**
 * Use this hook to get a reference to an object to retrieve application root configuration. In production this
 * is the configuration put on the div with id="application" in the HTML returned by the backend. In tests,
 * this will likely be stubbed by providing a stub implementation, like with
 * `ApplicationRootConfigurationSectionStub`.
 */
export const useApplicationRootConfiguration = () => useContext(ApplicationRootConfigurationContext);

/**
 * A context provider to provide a stub implementation for `useApplicationRootConfiguration`.
 */
export const ApplicationRootConfigurationProvider = ApplicationRootConfigurationContext.Provider;
